module.exports = __webpack_public_path__ + "img/QHC_logo_white.1afac23e.png";